import React from 'react';
import { Layout, Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Layout className="min-h-screen">
      <Content className="flex-center bg-gray-50">
        <Result
          status="404"
          title="404"
          subTitle="抱歉，您访问的页面不存在。"
          extra={
            <Button type="primary" onClick={() => navigate('/')}>
              返回首页
            </Button>
          }
        />
      </Content>
    </Layout>
  );
}
